import Notification from 'models/results/notification';
import { Pagination, PaginationResult } from 'types/pagination';
import { Filters } from 'types/filters';
import axios from 'utils/axios';
import { Data } from 'views/params-history/history';

class NotificationService {
    async getNotifications(tenantId: string): Promise<any> {
        try {
            const result = await axios.post<any>('/GetLast20Notifications', tenantId);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch last notifications');
        }
    }

    async isProgressNotification(tenantId: string): Promise<boolean> {
        try {
            const result = await axios.post<boolean>('/IsProgressNotification', tenantId);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch is progress notification');
        }
    }

    async getNotificationsPaginated(
        tenantId: string,
        filters: Filters<Data>,
        pagination: Pagination
    ): Promise<PaginationResult<Notification>> {
        try {
            const result = await axios.post<PaginationResult<Notification>>('/GetNotificationsPaginated', {
                ...filters,
                ...pagination,
                tenantId
            });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch last notifications');
        }
    }
}

export default NotificationService;
